import type { JSX } from 'preact'
import { createContext } from 'preact'
import { useState, useContext, useEffect } from 'preact/hooks'
import Front from '@frontapp/plugin-sdk'

type FrontContextType = any

export const FrontContext = createContext<FrontContextType | undefined>(undefined)

export function useFrontContext() {
  const context = useContext(FrontContext)
  return context
}

interface FrontContextProviderProps {
  children: JSX.Element | JSX.Element[]
}

export function FrontContextProvider({ children }: FrontContextProviderProps) {
  const [context, setContext] = useState<FrontContextType>()
  const [isInitialized, setIsInitialized] = useState(false)

  useEffect(() => {
    if (typeof Front === 'undefined') {
      console.warn('Front SDK is not available')
      return
    }

    try {
      setIsInitialized(true)

      const subscription = Front.contextUpdates.subscribe(frontContext => {
        console.log('front context', frontContext)
        setContext(frontContext)
      })

      return () => {
        if (subscription && typeof subscription.unsubscribe === 'function') {
          subscription.unsubscribe()
        }
      }
    } catch (error) {
      console.error('Error initializing Front SDK:', error, isInitialized)
    }
  }, [])

  return <FrontContext.Provider value={context}>{children}</FrontContext.Provider>
}

export function extractBookingId(context: FrontContextType): string | null {
  if (!context) return null

  if (context.type === 'singleConversation' && context.conversation) {
    if (context.conversation.links.length === 1) {
      const subject = context.conversation.links[0].name
      const bookingIdMatch = subject.match(/PLT\d+/)
      if (bookingIdMatch && bookingIdMatch[0]) {
        return bookingIdMatch[0]
      }
    }
  }

  return null
}

export function isFrontEmbedded(): boolean {
  return typeof Front !== 'undefined'
}
